 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"66765b6cd3f9759912b2c653a3f8cac1947a5fd3","2":"804231a33b9d24cc7392c9e2578f1b702e7393c9","3":"ee0141d9ca08eb14257bdea18f792128b81d78ad","4":"3a8af647cdad8f08fd16b9afc9f55b8d88641441","5":"49280b98bbc93c08c891e60ea9bc09366b488c10","6":"4dba7ca1c244b79db681beabef1f51c829473498","7":"7b81cb12bdb8379bedc466e0329df197a58a4e08","8":"651e1af2588ee04cccf46b0dcd76f4b2b622c713","9":"80a707c2665bf60f1af30fe3f33e6192a493b595","10":"b45e0e24f0de0d68278b9a447e571650e2051157","11":"component---src-pages-case-studies-clickup-js","12":"daf42ca166ab7e3dcbc4742e50e55d21e96b203c","19":"component---cache-caches-gatsby-plugin-offline-app-shell-js","20":"component---src-pages-404-tsx","21":"component---src-pages-banking-tsx","22":"component---src-pages-case-studies-gosite-tsx","23":"component---src-pages-case-studies-index-tsx","24":"component---src-pages-case-studies-quadpay-js","25":"component---src-pages-case-studies-quadpay-old-tsx","26":"component---src-pages-case-studies-tetra-tsx","27":"component---src-pages-case-studies-yotta-js","28":"component---src-pages-contact-tsx","29":"component---src-pages-fintech-2-tsx","30":"component---src-pages-fintech-tsx","31":"component---src-pages-index-js","32":"component---src-pages-privacy-tsx","33":"component---src-pages-what-we-do-tsx","34":"component---src-templates-case-study-tsx","35":"component---src-templates-insight-tsx","36":"component---src-templates-insights-tsx","37":"component---src-templates-service-tsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"018c811393c8c128ceb9","2":"1eeec8863f0242150bea","3":"45e1c2d30c48f5652d4f","4":"5a276d252e31257babdf","5":"ca495243b7bbb92a6940","6":"004258e012e6ed5a9b8a","7":"269a15ef2a770c6259bb","8":"64ffefec32d2de1f0501","9":"8ff6fcb7b638db80c711","10":"6131ef25ceb75368e963","11":"20caa581f16ac2c616ac","12":"ca57031a39f633e7b13f","19":"276fa93f115b097c94c6","20":"da1320f94ff09629e096","21":"75fc8263527b78cf9a43","22":"adce815745b71c70c64f","23":"7dc69cf7bd3c030462e8","24":"7450fca10e349bb87f04","25":"c4b684f63db77f375ba3","26":"a407022057b02ecb237c","27":"5035a9509db2416a427c","28":"36854c3b7ff52580a736","29":"21f28d0776c60cf11d68","30":"a6524f6bffdf3f158c86","31":"4dcdcaf2293a5fd4ef77","32":"b81970b288747b395bbe","33":"ac9ccf49d345ecd52d13","34":"96a3e5f172a6da29e5ab","35":"16171cf16d595cfc742a","36":"97cd39d74838f82dfa00","37":"00056e2894f0e5c7faf8","40":"7b3d8a8000cc687b8a6f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"66765b6cd3f9759912b2c653a3f8cac1947a5fd3","2":"804231a33b9d24cc7392c9e2578f1b702e7393c9","3":"ee0141d9ca08eb14257bdea18f792128b81d78ad","4":"3a8af647cdad8f08fd16b9afc9f55b8d88641441","5":"49280b98bbc93c08c891e60ea9bc09366b488c10","6":"4dba7ca1c244b79db681beabef1f51c829473498","7":"7b81cb12bdb8379bedc466e0329df197a58a4e08","8":"651e1af2588ee04cccf46b0dcd76f4b2b622c713","9":"80a707c2665bf60f1af30fe3f33e6192a493b595","10":"b45e0e24f0de0d68278b9a447e571650e2051157","11":"component---src-pages-case-studies-clickup-js","12":"daf42ca166ab7e3dcbc4742e50e55d21e96b203c","19":"component---cache-caches-gatsby-plugin-offline-app-shell-js","20":"component---src-pages-404-tsx","21":"component---src-pages-banking-tsx","22":"component---src-pages-case-studies-gosite-tsx","23":"component---src-pages-case-studies-index-tsx","24":"component---src-pages-case-studies-quadpay-js","25":"component---src-pages-case-studies-quadpay-old-tsx","26":"component---src-pages-case-studies-tetra-tsx","27":"component---src-pages-case-studies-yotta-js","28":"component---src-pages-contact-tsx","29":"component---src-pages-fintech-2-tsx","30":"component---src-pages-fintech-tsx","31":"component---src-pages-index-js","32":"component---src-pages-privacy-tsx","33":"component---src-pages-what-we-do-tsx","34":"component---src-templates-case-study-tsx","35":"component---src-templates-insight-tsx","36":"component---src-templates-insights-tsx","37":"component---src-templates-service-tsx"}[chunkId]||chunkId) + "." + {"0":"ec4b1e5cefe64a2d51f2","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
